module.exports = __webpack_public_path__ + "img/cast.a9212122.svg";